<template>
    <fieldset>
        <!-- Address Fields -->
        <h3 class="form-heading">{{ trans('user') }}</h3>
        <txt label="first_name" v-model="model.first_name"></txt>
        <txt label="last_name" v-model="model.last_name"></txt>
        <txt label="email" v-model="model.email"></txt>
        <txt label="change_password" v-model="model.password"></txt>
        <input type="checkbox" value="true" v-model="model.active" /> <label>Active</label><br>

        <button class="btn btn-primary" @click.prevent="viewSales">View Sales</button>
        <button class="btn btn-primary" @click.prevent="viewCompanies">View Companies</button>

        <button class="btn btn-primary" @click.prevent="store">Save</button>
    </fieldset>
</template>

<script>
    export default {
        props: {
            name: { default : '' }
        },
        data: function() {
            return {
                model: {
                    id: 0,
                    active: true,
                    first_name: '',
                    last_name: '',
                    email: '',
                    password: ''
                }
            }
        },
        created() {
            this.$eventHub.$on('setUser', this.setUser);
        },
        methods: {
            viewSales() {
                window.location = '/invoice/search?user_id=' + this.model.id;
            },
            viewCompanies() {
                window.location = '/company/search?user_id=' + this.model.id;
            },
            store() {
                this.$store('/api/user/update', this);
            },
            setUser(data) {
                let vm = this;
                $.each(this.model, function (key, value) {
                    let val = '';
                    if (typeof data[key] !== 'undefined') {
                        val = data[key];
                    }
                    vm.model[key] = val;
                });
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('setUser', this.setUser);
        }
    }
</script>
